import api from '../index';

export type UpdateBrandInstagramBusinessAccountParams = {
  brandId: string;
  brandInstagramBusinessAccountId: string;
  adsAccountId: string;
};

const brandInstagramBusinessAccountUpdaters = {
  updateAdsAccountId: async ({
    brandId,
    brandInstagramBusinessAccountId,
    adsAccountId,
  }: UpdateBrandInstagramBusinessAccountParams) => {
    return api.put(
      `/brand_instagram_business_account`,
      {
        brandId,
        brandInstagramBusinessAccountId,
        adsAccountId,
      },
      {
        params: {brand_id: brandId},
        customSerializer: () => ({
          data: {
            type: 'brand_instagram_business_accounts',
            id: brandInstagramBusinessAccountId,
            attributes: {
              ads_account_id: adsAccountId,
            },
          },
        }),
      }
    );
  },
};

export default brandInstagramBusinessAccountUpdaters;
